module.exports = __webpack_public_path__ + "img/4S-shop.ba716b45.png";